import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useDropzone } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  InputAdornment,
  Icon,
  IconButton,
  Button,
  Switch,
  FormControlLabel,
  Grid,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  InputBase,
  useTheme,
  useMediaQuery,
  FormHelperText,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

import { styled } from "@mui/material/styles";

import Breadcrumbs from "./components/Breadcrumbs";
import Button1 from "./components/Button1";
import FloatingMenu from "../components/FloatingMenu";

import styles from "./ToyImageUpload.module.css";

import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import ReviewsOutlinedIcon from "@mui/icons-material/ReviewsOutlined";

import waitVideo from "../assets/ReBoo-happy.mp4";
/////for drop-down varibles
// import categoryList from "./Variables/Category";
// import brandList from "./Variables/Brand";
// import conditionList from "./Variables/Condition";
// import warningList from "./Variables/Warning";
// import ageGroupList from "./Variables/AgeGroup";
// import materialList from "./Variables/Material";
// import colorList from "./Variables/Color";
// import subColorList from "./Variables/SubColor";
// import difficultyList from "./Variables/Difficulty";
// import countryList from "./Variables/Country";
///////////

import AiResultContent from "./AiResultContent";
import AlertPopup from "../components/AlertPopup";

import { useMutation, useManualQuery } from "graphql-hooks";
import {
  UPLOAD_FILES_S3_MUTATION,
  SET_FILES_AI_ATTRIBUTES_MUTATION,
  CHECK_AI_PASSWORD_QUERY,
  CANCEL_AI_ATTRIBUTES_MUTATION,
  UPLOAD_IMAGES_AND_SAVE_DATA_MUTATION,
  GET_TOY_ATTRIBUTES_QUERY,
  DELETE_S3_FILES_MUTATION,
} from "../graphQL/upload_files_s3";

const CustomHelperText = styled(FormHelperText)(({ theme }) => ({
  // textAlign: "left",
  fontSize: "14px",
  fontWeight: 500,
  color: "red#",
  // px: 5,
  // lineHeight: 0.5,
}));

const ToyImageUpload = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [toyUuid, setToyUuid] = useState(
    () => localStorage.getItem("userUuid") || uuidv4(),
  );
  const [email, setEmail] = useState(() => localStorage.getItem("email") || "");
  const [brand, setBrand] = useState("");
  const [brandList, setBrandList] = useState([]);
  const [conditions, setConditions] = useState("");
  const [conditionList, setConditionList] = useState([]);
  const [warnings, setWarnings] = useState("");
  const [warningList, setWarningList] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [subCategory, setSubCategory] = useState("Don't Care");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [dbSubCategory, setDbSubCategory] = useState("");
  const [curSubcategoryList, setCurSubcategoryList] = useState([]);
  const [material, setMaterial] = useState("Don't Care");
  const [materialList, setMaterialList] = useState([]);
  const [color, setColor] = useState("Don't Care");
  const [colorList, setColorList] = useState([]);
  const [subColor, setSubColor] = useState("Don't Care");
  const [subColorList, setSubColorList] = useState([]);
  const [ageGroup, setAgeGroup] = useState("Don't Care");
  const [ageGroupList, setAgeGroupList] = useState([]);
  const [difficulty, setDifficulty] = useState("Don't Care");
  const [difficultyList, setDifficultyList] = useState([]);
  const [manufacturerCountry, setManufacturerCountry] = useState("Don't Care");
  const [countryList, setCountryList] = useState([]);
  const [batteryRequired, setBatteryRequired] = useState(false);
  const [batteryIncluded, setBatteryIncluded] = useState(false);
  const [assemblyRequired, setAssemblyRequired] = useState(false);
  const [gameDuration, setGameDuration] = useState("");

  const [dimensions, setDimensions] = useState("");
  const [weight, setWeight] = useState("");
  const [noPlayers, setNoPlayers] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [originalPrice, setOriginalPrice] = useState("");

  const [tags, setTags] = useState([]);
  const [tagValue, setTagValue] = useState("");

  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);

  const inputRef = useRef(null);

  const maxTags = 10;
  const maxTagLength = 25;

  const validTagRegex = /^[\w\- ]+$/;
  const [images, setImages] = useState([]);

  const maxImgSize = 5 * 1024 * 1024; // Max size is 5 MB
  const maxImgNum = 6; // Max image to upload

  const [aiDlgSteps, setAiDlgSteps] = useState("idle");
  const [password, setPassword] = useState("");
  const [passDlgErrorMsg, setPassDlgErrorMsg] = useState("");
  const [aiRes, setAiRes] = useState({});
  const cancelAiRef = useRef(false);
  const [notToyRes, setNotToyRes] = useState("");
  const videoRef = useRef(null);
  const [videoLoopCount, setVideoLoopCount] = useState(0);

  const [uploadFilesToS3] = useMutation(UPLOAD_FILES_S3_MUTATION);
  const [setFilesAttrByAI] = useMutation(SET_FILES_AI_ATTRIBUTES_MUTATION);
  const [checkAiPassword] = useManualQuery(CHECK_AI_PASSWORD_QUERY);
  const [cancelAttrByAI] = useMutation(CANCEL_AI_ATTRIBUTES_MUTATION);
  const [uploadImagesAndSaveData] = useMutation(UPLOAD_IMAGES_AND_SAVE_DATA_MUTATION);
  const [getToyAttributes] = useManualQuery(GET_TOY_ATTRIBUTES_QUERY);
  const [deleteS3Files] = useMutation(DELETE_S3_FILES_MUTATION);

  // Scroll page to Required field when it is empty and "Save" button is clicked
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const categoryRef = useRef(null);
  const sellingRef = useRef(null);
  const brandRef = useRef(null);
  const warningsRef = useRef(null);
  const conditionRef = useRef(null);

  const [errorMsg, setErrorMsg] = useState({
    title: "",
    description: "",
    sellingPrice: "",
    brand: "",
    condition: "",
    warnings: "",
    category: "",
    tag: "",
  });

  useEffect(() => {
    (async () => setToyAttributeslist())();
  }, []);

  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  const normalizeToTitleList = dataArray => {
    if (!Array.isArray(dataArray)) return [];
    return dataArray
      .filter(item => item && item.title)
      .map(item => item.title.trim())
      .sort((a, b) => a.localeCompare(b));
  };

  const normalizeToNameList = dataArray => {
    if (!Array.isArray(dataArray)) return [];
    return dataArray
      .filter(item => item && item.name)
      .map(item => item.name.trim())
      .sort((a, b) => a.localeCompare(b));
  };
  const setToyAttributeslist = async () => {
    const {
      loading: loadingToyAttributes,
      error: errorToyAttributes,
      data: dataToyAttributes,
    } = await getToyAttributes();
    if (!loadingToyAttributes && dataToyAttributes) {
      setCategoryList(normalizeToTitleList(dataToyAttributes.categories));
      setDbSubCategory(dataToyAttributes.subcategories);
      setBrandList(normalizeToTitleList(dataToyAttributes.brands));
      setAgeGroupList(normalizeToTitleList(dataToyAttributes.ageGroups));
      setWarningList(normalizeToTitleList(dataToyAttributes.warnings));
      setMaterialList(normalizeToTitleList(dataToyAttributes.materials));
      setColorList(normalizeToTitleList(dataToyAttributes.colors));
      setSubColorList(normalizeToTitleList(dataToyAttributes.subColors));
      setDifficultyList(normalizeToTitleList(dataToyAttributes.difficulties));
      setCountryList(normalizeToNameList(dataToyAttributes.manufacturerCountries));
      setConditionList(normalizeToTitleList(dataToyAttributes.conditions));
    }
  };

  useEffect(() => {
    if (dbSubCategory.length > 0) {
      const grouped = dbSubCategory.reduce((acc, sub) => {
        const catTitle = sub.category.title;
        if (!acc[catTitle]) acc[catTitle] = [];
        acc[catTitle].push(sub.title);
        return acc;
      }, {});

      Object.keys(grouped).forEach(key => {
        grouped[key].sort((a, b) => a.localeCompare(b));
      });

      const sortedGrouped = Object.fromEntries(
        Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b)),
      );

      setSubCategoryList(sortedGrouped);
    }
  }, [dbSubCategory]);

  // Handle Upload Image
  const onDrop = acceptedFiles => {
    showImageFunc(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
    maxFiles: 1,
  });

  const selectImageFunc = event => {
    const fileList = Array.from(event.target.files);
    showImageFunc(fileList);
  };

  const addTimeStampToFilename = fileName => {
    const ext = fileName.substring(fileName.lastIndexOf("."));
    const name = fileName.substring(0, fileName.lastIndexOf("."));
    const timestamp = Date.now();
    return `${name}_${timestamp}${ext}`;
  };

  const showImageFunc = fileList => {
    // Check number of file
    const remainingSlots = maxImgNum - images.length;
    if (remainingSlots <= 0) {
      setAiDlgSteps("maxImgNum");
      return;
    }
    // Check file size
    if (fileList[0].size > maxImgSize) {
      setAiDlgSteps("imgSize");
      return;
    }
    const newImages = fileList.map(file => {
      // console.log(file);
      return {
        file,
        url: URL.createObjectURL(file),
        s3Url: "",
        s3FileName: addTimeStampToFilename(file.name),
      };
    });
    setImages(prev => [...prev, ...newImages]);
  };

  // Password Dialg functions
  const handlePassDlgOpen = () => setAiDlgSteps("waiting"); //"password");waiting; result

  const handleAiDlgClose = () => {
    setAiDlgSteps("idle");
    setPassword("");
    setPassDlgErrorMsg("");
    setAiRes({});
    setVideoLoopCount(0);
  };

  const handlePassConfirm = async () => {
    try {
      // Set related Parameters
      cancelAiRef.current = false;
      setAiDlgSteps("waiting");

      // Check Password
      // const { data, error } = await checkAiPassword({
      //   variables: { password },
      // });

      // if (error || !data.checkAiPassword) {
      //   setPassDlgErrorMsg("Password is incorrect!");
      //   return;
      // }

      // Upload files on S3
      const lastImage = images.length > 0 ? images[images.length - 1] : null;
      if (!lastImage) return;
      let lastImageFile = [lastImage.file];
      let lastImageS3Url = lastImage.s3Url;
      let lastImageFileName = lastImage.s3FileName;
      if (lastImageS3Url == "") {
        const { data: uploadData, error: uploadError } = await uploadFilesToS3({
          variables: {
            files: lastImageFile,
            fileName: lastImageFileName,
            fileUuid: toyUuid,
          },
        });
        if (cancelAiRef.current) return;
        if (uploadError) {
          if (uploadError.graphQLErrors)
            console.log(uploadError.graphQLErrors[0].message);
          else console.log(uploadError);
          return;
        } else {
          lastImageS3Url = uploadData.uploadFilesToS3.urls[0];
          console.log("S3 URLs:", lastImageS3Url);
        }
      }

      // Check if we should continue the process
      if (cancelAiRef.current) return;
      // Get file's Attributes with Open AI
      const { data: aiData, error: aiError } = await setFilesAttrByAI({
        variables: {
          s3Urls: lastImageS3Url,
        },
      });
      if (cancelAiRef.current) return;
      if (aiError) {
        if (aiError.graphQLErrors) console.log(aiError.graphQLErrors[0].message);
        else console.log(aiError);
      } else {
        let aiRetValue = aiData.setFilesAiAttributes.attributes[0];
        if (typeof aiRetValue === "string") {
          try {
            const aiCleanValue = aiRetValue
              .replace(/```json/i, "")
              .replace(/```/g, "")
              .trim();

            aiRetValue = JSON.parse(aiCleanValue);
          } catch (e) {
            console.error("Invalid JSON format:", e);
          }
        }
        console.log(aiRetValue);
        // console.log(aiRetValue.isToy);
        if (aiRetValue.isToy === false) {
          setAiDlgSteps("toyFalse");
          setNotToyRes(aiRetValue.reason);
          return;
        }

        // Set the Undefined OR Unknow values to Don't Care
        for (const key in aiRetValue) {
          const value = aiRetValue[key];
          if (
            value === null ||
            value === undefined ||
            value === "" ||
            (typeof value === "string" &&
              value.trim().toLowerCase() === "not specified") ||
            (typeof value === "string" && value.trim().toLowerCase() === "unknown")
          ) {
            aiRetValue[key] = "Don’t Care";
          }
        }
        setAiRes(aiRetValue);
        setAiDlgSteps("result");
        setImages(prev =>
          prev.map((img, index) =>
            index === prev.length - 1 ? { ...img, s3Url: lastImageS3Url } : img,
          ),
        );
      }
    } catch (err) {
      if (cancelAiRef.current) return;
      console.error(err);
      setPassDlgErrorMsg("Unexpected error!");
    }
  };

  const handleAiAnalysisDlgClose = () => {
    setAiDlgSteps("idle");
    setAiRes({});
  };

  const handleAiAnalysisCancel = () => {
    handleAiDlgClose();
    cancelAiRef.current = true;
    stopAiAnalysis();
  };

  const stopAiAnalysis = async () => {
    try {
      const { data, error } = await cancelAttrByAI();
      if (error) {
        alert(error);
        return;
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (videoLoopCount >= 2 && aiDlgSteps === "waiting") {
      videoRef.current.pause();
      setAiDlgSteps("timeOut");
      stopAiAnalysis();
    }
  }, [videoLoopCount]);

  const handleVideoEnded = () => {
    setVideoLoopCount(prev => prev + 1);
    if (videoLoopCount < 1 && aiDlgSteps === "waiting") {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  const isPositiveInteger = value => /^\d+$/.test(value);

  const handleAiAnalysisConfirm = (requiredAttriCheckVals, optionalAttriCheckVals) => {
    let titleErrFlg = false;
    let desErrFlg = false;
    let catgErrFlg = false;
    let brandErrFlg = false;
    let wargsErrFlg = false;

    if (requiredAttriCheckVals.title) {
      setTitle(aiRes.Title);
      if (aiRes.Title.trim() === "") titleErrFlg = true;
    }
    if (requiredAttriCheckVals.description) {
      setDescription(aiRes.Description);
      if (aiRes.Description.trim() === "") desErrFlg = true;
    }
    if (requiredAttriCheckVals.brand) {
      let brndVal = aiRes.Brand;
      if (brndVal.trim() === "Don’t Care") {
        setBrand("");
      } else setBrand(brndVal);

      if (brndVal.trim() === "") brandErrFlg = true;
    }
    if (requiredAttriCheckVals.category) {
      setCategory(aiRes.Category);
      if (aiRes.Category.trim() === "") catgErrFlg = true;
    }
    if (requiredAttriCheckVals.warnings) {
      setWarnings(aiRes.Warnings);
      if (aiRes.Warnings.trim() === "") wargsErrFlg = true;
    }

    if (requiredAttriCheckVals.subcategory && requiredAttriCheckVals.category) {
      console.log("&&&&&&&&&&&&&&&&&");
      console.log(aiRes.Subcategory);
      console.log(aiRes.Category);
      console.log(subCategoryList);
      console.log(subCategoryList[aiRes.Category]);
      setCurSubcategoryList(subCategoryList[aiRes.Category]);
      setSubCategory(aiRes.Subcategory);
    }

    if (optionalAttriCheckVals.material) setMaterial(aiRes.Material);
    if (optionalAttriCheckVals.color) setColor(aiRes.Color);
    if (optionalAttriCheckVals.subcolor) setSubColor(aiRes["Sub-Color"]);
    if (optionalAttriCheckVals.age) setAgeGroup(aiRes["Age Group"]);
    if (optionalAttriCheckVals.difficulty) setDifficulty(aiRes["Level of Difficulty"]);
    if (optionalAttriCheckVals.country)
      setManufacturerCountry(aiRes["Manufacturer Country"]);
    if (optionalAttriCheckVals.BatteryReq)
      setBatteryRequired(aiRes["Battery Required"] === "Yes");
    if (optionalAttriCheckVals.BatteryIncd)
      setBatteryIncluded(aiRes["Battery Included"] === "Yes");
    if (optionalAttriCheckVals.assemblyReq)
      setAssemblyRequired(aiRes["Assembly Required"] === "Yes");

    if (optionalAttriCheckVals.dimensions) setDimensions(aiRes.Dimensions);
    // if (optionalAttriCheckVals.weight) setWeight(aiRes.Weight);
    if (optionalAttriCheckVals.players) {
      let val = aiRes["No of Players"];
      if (isPositiveInteger(val)) setNoPlayers(val);
    }
    if (optionalAttriCheckVals.duration) {
      let val = aiRes["Game Duration"];
      if (isPositiveInteger(val)) setGameDuration(val);
    }

    setErrorMsg({
      ...errorMsg,
      title: titleErrFlg ? "Title/Summary cannot be blank." : "",
      description: desErrFlg ? "Description cannot be blank." : "",
      category: catgErrFlg ? "Category cannot be blank." : "",
      warnings: wargsErrFlg ? "Warnings cannot be blank." : "",
      brand: brandErrFlg ? "Brand cannot be blank." : "",
    });

    handleAiDlgClose();
  };

  // // Define subcategory options based on category
  // const getSubcategoryOptions = selectedCategory => {
  //   let sub = categoryList.find(item => item.value === selectedCategory);
  //   if (sub) return sub.subCategory;
  //   else return [];
  // };

  const FilterSelect = styled(MUISelect)(({ theme }) => ({
    height: "56px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9",
    },
  }));

  // Handle category change and reset subcategory
  const handleCategoryChange = event => {
    const newCategory = event.target.value;
    setCategory(newCategory);
    setCurSubcategoryList(subCategoryList[newCategory]);
    setSubCategory("Don't Care"); // Reset subcategory when category changes
    setErrorMsg({
      ...errorMsg,
      category: "",
    });
  };

  const handleTitleChange = event => {
    setTitle(event.target.value);
    if (event.target.value.trim() === "")
      setErrorMsg({
        ...errorMsg,
        title: "Title/Summary cannot be blank.",
      });
    else
      setErrorMsg({
        ...errorMsg,
        title: "",
      });
  };

  const handleDescriptionChange = event => {
    setDescription(event.target.value);
    if (event.target.value.trim() === "")
      setErrorMsg({
        ...errorMsg,
        description: "Description cannot be blank.",
      });
    else
      setErrorMsg({
        ...errorMsg,
        description: "",
      });
  };

  const handleSellingPriceChange = event => {
    setSellingPrice(event.target.value);
    if (event.target.value.trim() === "")
      setErrorMsg({
        ...errorMsg,
        sellingPrice: "Selling Price cannot be blank.",
      });
    else
      setErrorMsg({
        ...errorMsg,
        sellingPrice: "",
      });
  };

  const handleBrandChange = event => {
    setBrand(event.target.value);
    setErrorMsg({
      ...errorMsg,
      brand: "",
    });
  };

  const handleConditionsChange = event => {
    setConditions(event.target.value);
    setErrorMsg({
      ...errorMsg,
      condition: "",
    });
  };

  const handleWarningsChange = event => {
    setWarnings(event.target.value);
    setErrorMsg({
      ...errorMsg,
      warnings: "",
    });
  };

  const cleanTag = str => str.trim().replace(/\s+/g, " ");

  const addTag = () => {
    // Normalize the input:

    // Trim and reduce multiple spaces to one
    let trimmed = cleanTag(tagValue);

    if (!trimmed) return;

    // Validation
    if (tags.some(tag => tag.toLowerCase() === trimmed.toLowerCase())) {
      setErrorMsg({ tag: "You already added this tag." });
      return;
    }
    if (tags.length >= maxTags) {
      setErrorMsg({ tag: `Maximum ${maxTags} tags allowed.` });
      return;
    }
    if (trimmed.length > maxTagLength) {
      setErrorMsg({ tag: `Tag must be under ${maxTagLength} characters.` });
      return;
    }
    if (!validTagRegex.test(trimmed)) {
      setErrorMsg({
        tag: "Only letters, numbers, dashes, underscores, and spaces are allowed.",
      });
      return;
    }

    setTags([...tags, trimmed]);
    setTagValue("");
    setErrorMsg({ tag: "" });
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    } else if (e.key === "Backspace" && tagValue === "") {
      if (tags.length > 0) {
        e.preventDefault();
        const updatedTags = [...tags];
        updatedTags.pop();
        setTags(updatedTags);
        setErrorMsg({ tag: "" });
      }
    }
  };

  const handleDelete = tagToDelete => {
    setTags(tags.filter(tag => tag !== tagToDelete));
    setErrorMsg({ tag: "" });
  };

  function ClosableSelect({ children, ...props }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
      if (!open) return;

      const handleScroll = event => {
        if (open) {
          // Check if the scroll event is coming from inside the dropdown
          const isScrollingInsideDropdown =
            (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
            (ref.current && ref.current.contains(event.target));

          // Only close if NOT scrolling inside the dropdown
          if (!isScrollingInsideDropdown) {
            setOpen(false);
          }
        }
      };

      //const handleScroll = () => setOpen(false);

      const handleClickOutside = event => {
        // Check if click is inside the select component or dropdown menu
        const isClickInsideSelect = ref.current && ref.current.contains(event.target);
        const isClickInsideDropdown =
          dropdownRef.current && dropdownRef.current.contains(event.target);

        // Only close if click is outside both the select and dropdown
        if (!isClickInsideSelect && !isClickInsideDropdown) {
          setOpen(false);
        }
        //if (ref.current && !ref.current.contains(event.target)) {
        // setOpen(false);
        //}
      };

      if (open) {
        // Listen for scroll events on all scrollable elements
        document.addEventListener("scroll", handleScroll, true);
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [open]);

    return (
      <FilterSelect
        ref={ref}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            ref: dropdownRef,
          },
        }}
        {...props}
      >
        {children}
      </FilterSelect>
    );
  }

  const handleRemoveImage = rmvImg => {
    setImages(prevImages =>
      prevImages.filter(img => img.s3FileName !== rmvImg.s3FileName),
    );
  };
  const handleSavePost = async publish => {
    // At least one image is uploaded when "SAVE & POST" is clicked
    if (publish && images.length == 0) {
      setAiDlgSteps("minImgNum");
      return;
    }
    // Validate data
    let errFlg = false;
    let titleErrFlg = false;
    let desErrFlg = false;
    let catgErrFlg = false;
    let sellPriceErrFlg = false;
    let brandErrFlg = false;
    let wargsErrFlg = false;
    let condErrFlg = false;

    if (conditions.trim() === "") {
      conditionRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      conditionRef.current?.focus();
      condErrFlg = true;
      errFlg = true;
    }
    if (warnings.trim() === "") {
      warningsRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      warningsRef.current?.focus();
      wargsErrFlg = true;
      errFlg = true;
    }
    if (brand.trim() === "") {
      brandRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      brandRef.current?.focus();
      brandErrFlg = true;
      errFlg = true;
    }
    if (sellingPrice.trim() === "") {
      sellingRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      sellingRef.current?.focus();
      sellPriceErrFlg = true;
      errFlg = true;
    }
    if (category.trim() === "") {
      categoryRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      categoryRef.current?.focus();
      catgErrFlg = true;
      errFlg = true;
    }
    if (description.trim() === "") {
      descriptionRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      descriptionRef.current?.focus();
      desErrFlg = true;
      errFlg = true;
    }
    if (title.trim() === "") {
      titleRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      titleRef.current?.focus();
      titleErrFlg = true;
      errFlg = true;
    }

    if (errFlg) {
      setErrorMsg({
        ...errorMsg,
        title: titleErrFlg ? "Title/Summary cannot be blank." : "",
        description: desErrFlg ? "Description cannot be blank." : "",
        category: catgErrFlg ? "Category cannot be blank." : "",
        warnings: wargsErrFlg ? "Warnings cannot be blank." : "",
        condition: condErrFlg ? "Conditions cannot be blank." : "",
        brand: brandErrFlg ? "Brand cannot be blank." : "",
        sellingPrice: sellPriceErrFlg ? "Selling price cannot be blank." : "",
      });
      return;
    }

    const { data: saveImagesData, error: saveDataError } = await uploadImagesAndSaveData({
      variables: {
        imagesData: images.map(img => ({
          file: img.file,
          s3FileName: img.s3FileName,
          s3Url: img.s3Url,
        })),
        email,
        category,
        subCategory,
        title,
        description,
        material,
        brand,
        conditions,
        warnings,
        color,
        subColor,
        ageGroup,
        difficulty,
        manufacturerCountry,
        dimensions,
        weight,
        sellingPrice,
        originalPrice,
        noPlayers,
        gameDuration,
        batteryRequired,
        batteryIncluded,
        assemblyRequired,
        isPublished: publish,
        tags,
      },
    });

    if (saveDataError) {
      console.log(saveDataError);
    } else {
      console.log(saveImagesData.uploadImagesAndSaveData.success);
      navigate(`/my-toys`);
    }
  };

  const handleCancelBtn = async () => {
    const s3UrlVals = images
      .filter(item => item.s3Url) // s3Url is not empty
      .map(item => item.s3Url); // return s3Url values

    const { data: deleteS3FilesData, error: deleteS3FilesError } = await deleteS3Files({
      variables: {
        s3Urls: s3UrlVals,
      },
    });
    if (deleteS3FilesError) {
      console.log(deleteS3FilesError);
    } else {
      console.log(deleteS3FilesData.deleteS3Files.success);
      navigate(`/`);
    }
  };
  // console.log("tags: ", tags);
  // console.log("tagValue: ", tagValue);
  // console.log("images: ", images);
  // console.log("toyUuid", toyUuid);
  // console.log("videoLoopCount: ", videoLoopCount);
  // console.log("aiDlgSteps: ", aiDlgSteps);

  return (
    <>
      <Box className={styles.toyImageUpload}>
        <Helmet>
          <title>R3PLAY - Add Your Toy</title>
          <meta
            name="description"
            content="Upload your toy to R3PLAY. Add photos, description, and set it for sale, trade, or showcase."
          />
          <meta
            property="keywords"
            content="Add toy, sell toys, upload toy, toy listing, share toys"
          />
        </Helmet>
        <main
          className={styles.midContent}
          sx={{
            px: "100px",
            "@media (max-width: 1360px)": {
              px: "16px",
            },
          }}
        >
          <section className={styles.container}>
            <Box className={styles.insideContainer}>
              <section className={styles.uploadYourToy}>
                <Box className={styles.left}>
                  <Typography
                    className={styles.toyImageUploadUploadYourToy}
                    variant="inherit"
                    variantMapping={{ inherit: "h3" }}
                    sx={{ fontWeight: "700" }}
                  >
                    Upload Your Toy
                  </Typography>
                  <div className={styles.shareYourToy}>
                    Share your toy with detailed information and photos
                  </div>
                </Box>
              </section>
              <section className={styles.uploadToyCard}>
                <Box
                  sx={{
                    alignSelf: "stretch",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box className={styles.photooutlinedParent}>
                    <InsertPhotoOutlinedIcon
                      sx={{ borderColor: "#EF5658", color: "#EF5658" }}
                    />

                    <Typography
                      className={styles.photoUpload}
                      variant="inherit"
                      variantMapping={{ inherit: "h3" }}
                      sx={{ fontWeight: "500" }}
                    >
                      Photo Upload
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    // color="primary"
                    sx={{ textTransform: "none", backgroundColor: "#EF5658" }}
                    disabled={images.length === 0}
                    onClick={handlePassConfirm} //{handlePassDlgOpen}
                  >
                    AI Assistant
                  </Button>
                </Box>
                {/* Drag & Drop Box */}
                <Box
                  className={styles.innerCard}
                  {...getRootProps()}
                  sx={{
                    bgcolor: isDragActive ? "grey.100" : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <input
                    {...getInputProps()}
                    className={styles.input}
                    type="file"
                    // id="file-3:178"
                    accept="image/*"
                    onChange={selectImageFunc}
                  />
                  <label className={styles.label}>
                    <FileUploadOutlinedIcon
                      color="action"
                      sx={{ height: "56px", width: "56px" }}
                    />
                    {isDragActive ? (
                      <Typography
                        className={styles.dropPhotosHere}
                        variant="inherit"
                        variantMapping={{ inherit: "h3" }}
                        sx={{ fontWeight: "600" }}
                        color="primary"
                      >
                        Drop photos here...
                      </Typography>
                    ) : (
                      <Typography
                        className={styles.dropPhotosHere}
                        variant="inherit"
                        variantMapping={{ inherit: "h3" }}
                        sx={{ fontWeight: "600" }}
                      >
                        Drop photos here or click to browse
                      </Typography>
                    )}
                    <div className={styles.supportForJpg}>
                      Support for JPG, PNG, WEBP formats
                    </div>
                    <div className={styles.max5mbPer}>
                      Max 5MB per image, Up to 6 images
                    </div>
                  </label>
                  {/* <input className={styles.input} type="file" id="file-3:178" /> */}
                </Box>
                {/* Image Display */}
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  {images.map((img, index) => (
                    <Grid item key={index}>
                      <Box
                        sx={{
                          position: "relative",
                          width: "174.67px",
                          "@media (max-width: 856px)": {
                            width: "156px",
                          },
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveImage(img)}
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            "@media (max-width: 856px)": {
                              top: 6,
                              right: 6,
                            },
                            backgroundColor: "white",
                            boxShadow: 1,
                            zIndex: 1,
                            width: "24px",
                            height: "24px",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <Box
                          component="img"
                          src={img.url}
                          alt={img.file.name}
                          sx={{
                            width: "174.67px",
                            height: "174.67px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            border: "1px solid #ddd",
                            "@media (max-width: 856px)": {
                              width: "156px",
                              height: "156px",
                            },
                          }}
                        />
                        <Box sx={{ textAlign: "center", mt: 2 }}>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: "#666",
                            }}
                          >
                            File: {img.file.name}
                          </Typography>
                          <Typography
                            sx={{
                              mt: 1,
                              color: "#999",
                              fontSize: "12px",
                            }}
                          >
                            Size:{" "}
                            {img.file.size < 1024 * 1024
                              ? `${Math.round(img.file.size / 1024)} KB`
                              : `${(img.file.size / (1024 * 1024)).toFixed(2)} MB`}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Box>
              </section>
              <Box className={styles.requiredInformation}>
                <Box className={styles.photooutlinedParent}>
                  <ListAltOutlinedIcon
                    sx={{ borderColor: "#EF5658", color: "#EF5658" }}
                  />

                  <div className={styles.requiredInformationMustContainer}>
                    <Typography variant="inherit" variantMapping={{ inherit: "span" }}>
                      Required Information{` `}
                    </Typography>
                    <Typography
                      variant="inherit"
                      variantMapping={{ inherit: "span" }}
                      sx={{ fontSize: "var(--font-size-14)" }}
                    >
                      (Must fill before posting)
                    </Typography>
                  </div>
                </Box>
                <TextField
                  className={styles.textfield}
                  label="Title/Summary"
                  placeholder="Enter Title/Summary"
                  variant="outlined"
                  required
                  value={title}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={handleTitleChange}
                  error={!!errorMsg.title}
                  inputRef={titleRef}
                />
                {errorMsg.title && (
                  <CustomHelperText error>{errorMsg.title}</CustomHelperText>
                )}
                <TextField
                  className={styles.textfield}
                  label="Description"
                  placeholder="Enter Description"
                  variant="outlined"
                  multiline
                  maxRows={10}
                  rows={4}
                  required
                  value={description}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "auto" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={handleDescriptionChange}
                  error={!!errorMsg.description}
                  inputRef={descriptionRef}
                />
                {errorMsg.description && (
                  <CustomHelperText error>{errorMsg.description}</CustomHelperText>
                )}

                <Box className={styles.row}>
                  <FormControl
                    ref={categoryRef}
                    sx={{
                      minWidth: 200,
                      "@media (max-width: 856px)": {
                        width: "100%",
                      },
                      "@media (min-width: 857px)": {
                        mr: 2,
                      },

                      "& .MuiOutlinedInput-root": { height: "56px" },
                      "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                      "& .MuiInputLabel-asterisk": { color: "#ef5658 !important" },
                      "& .MuiFormLabel-asterisk": { color: "#ef5658 !important" },
                    }}
                  >
                    <InputLabel id="category-select-label" className="red-asterisk-label">
                      Category
                    </InputLabel>
                    <ClosableSelect
                      labelId="category-select-label"
                      id="category-select"
                      value={category}
                      label="Category"
                      required
                      onChange={handleCategoryChange}
                      error={!!errorMsg.category}
                    >
                      {categoryList.map(option => (
                        <MenuItem value={option}>{option}</MenuItem>
                      ))}
                    </ClosableSelect>
                    {errorMsg.category && (
                      <CustomHelperText error>{errorMsg.category}</CustomHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    sx={{
                      minWidth: 200,
                      flex: 1,
                      "& .MuiOutlinedInput-root": { height: "56px" },
                      "& .MuiInputLabel-root": { color: "black" },
                      "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    }}
                  >
                    <InputLabel id="subcategory-select-label" style={{ color: "#000" }}>
                      Subcategory
                    </InputLabel>
                    <ClosableSelect
                      labelId="subcategory-select-label"
                      id="subcategory-select"
                      value={subCategory}
                      label="Subcategory"
                      required
                      disabled={!category} // Disable if no category is selected
                      onChange={e => setSubCategory(e.target.value)}
                    >
                      {curSubcategoryList.map(option => (
                        <MenuItem value={option}>{option}</MenuItem>
                      ))}
                    </ClosableSelect>
                  </FormControl>
                </Box>

                <TextField
                  className={styles.textfield}
                  label="Selling Price ($)"
                  placeholder="Enter Selling Price"
                  variant="outlined"
                  required
                  value={sellingPrice}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={handleSellingPriceChange}
                  error={!!errorMsg.sellingPrice}
                  inputRef={sellingRef}
                />
                {errorMsg.sellingPrice && (
                  <CustomHelperText error>{errorMsg.sellingPrice}</CustomHelperText>
                )}

                <TextField
                  className={styles.textfield}
                  label="Original Price ($)"
                  placeholder="Enter Original Price"
                  value={originalPrice}
                  variant="outlined"
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={e => setOriginalPrice(e.target.value)}
                />
                <FormControl
                  ref={brandRef}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputLabel-asterisk": { color: "#ef5658 !important" },
                    "& .MuiFormLabel-asterisk": { color: "#ef5658 !important" },
                  }}
                >
                  <InputLabel id="brand-select-label" className="red-asterisk-label">
                    Brand
                  </InputLabel>
                  <ClosableSelect
                    labelId="brand-select-label"
                    id="brand-select"
                    value={brand}
                    label="Brand"
                    onChange={handleBrandChange}
                    required
                    error={!!errorMsg.brand}
                  >
                    {brandList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                  {errorMsg.brand && (
                    <CustomHelperText error>{errorMsg.brand}</CustomHelperText>
                  )}
                </FormControl>
                <FormControl
                  ref={conditionRef}
                  fullWidth
                  sx={{
                    mt: 2,
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputLabel-asterisk": { color: "#ef5658 !important" },
                    "& .MuiFormLabel-asterisk": { color: "#ef5658 !important" },
                  }}
                >
                  <InputLabel id="conditions-select-label" className="red-asterisk-label">
                    Conditions
                  </InputLabel>
                  <ClosableSelect
                    labelId="conditions-select-label"
                    id="conditions-select"
                    value={conditions}
                    label="Conditions"
                    required
                    onChange={handleConditionsChange}
                    error={!!errorMsg.condition}
                  >
                    {conditionList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                  {errorMsg.condition && (
                    <CustomHelperText error>{errorMsg.condition}</CustomHelperText>
                  )}
                </FormControl>
                <FormControl
                  ref={warningsRef}
                  fullWidth
                  sx={{
                    mt: 2,
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputLabel-asterisk": { color: "#ef5658 !important" },
                    "& .MuiFormLabel-asterisk": { color: "#ef5658 !important" },
                  }}
                >
                  <InputLabel id="warnings-select-label" className="red-asterisk-label">
                    Warnings
                  </InputLabel>
                  <ClosableSelect
                    labelId="warnings-select-label"
                    id="warnings-select"
                    value={warnings}
                    label="Warnings"
                    required
                    onChange={handleWarningsChange}
                    error={!!errorMsg.warnings}
                  >
                    {warningList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                  {errorMsg.warnings && (
                    <CustomHelperText error>{errorMsg.warnings}</CustomHelperText>
                  )}
                </FormControl>
              </Box>
              <section className={styles.addTags}>
                <Box className={styles.photooutlinedParent}>
                  <SellOutlinedIcon sx={{ borderColor: "#EF5658", color: "#EF5658" }} />

                  <Typography
                    className={styles.tags}
                    variant="inherit"
                    variantMapping={{ inherit: "h3" }}
                    sx={{ fontWeight: "500" }}
                  >
                    Tags
                  </Typography>
                </Box>
                {/* Custom text field that contains tags and input inline */}
                <Box
                  className={styles.autocomplete}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    border: "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    minHeight: "56px",
                    cursor: "text",
                  }}
                  onClick={() => inputRef.current?.focus()}
                >
                  {tags.map((tag, index) => (
                    <Chip
                      key={index}
                      label={tag}
                      onDelete={() => handleDelete(tag)}
                      sx={{
                        m: "4px 4px 4px 0",
                        backgroundColor: "#e0e0e0",
                        height: "32px",
                        fontSize: "16px",
                      }}
                    />
                  ))}

                  <InputBase
                    inputRef={inputRef}
                    value={tagValue}
                    onChange={e => {
                      setTagValue(e.target.value);
                      setErrorMsg({ tag: "" });
                    }}
                    onKeyDown={handleKeyDown}
                    onBlur={() => {
                      // Optional: auto-add when user taps away
                      if (isMobile) {
                        addTag();
                      }
                    }}
                    placeholder="Add a tag and press Enter"
                    sx={{
                      flex: 1,
                      minWidth: "120px",
                      fontSize: "16px",
                      color: "rgba(0, 0, 0, 0.6)",
                      m: "4px 0",
                    }}
                  />
                  {/* "+" icon button - shown only on mobile + has input */}
                  {isMobile && tagValue.trim().length > 0 && (
                    <IconButton
                      onClick={addTag}
                      size="small"
                      sx={{ ml: 0.5 }}
                      aria-label="Add tag"
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>

                {errorMsg.tag && (
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "left",
                      color: "red",
                      pr: 5,
                      fontSize: "14px",
                      lineHeight: 1.2,
                    }}
                  >
                    {errorMsg.tag}
                  </Typography>
                )}
              </section>
              <Box className={styles.optionalInformation}>
                <Box className={styles.photooutlinedParent}>
                  <ListAltOutlinedIcon
                    sx={{ borderColor: "#EF5658", color: "#EF5658" }}
                  />
                  <div className={styles.requiredInformationMustContainer}>
                    <Typography variant="inherit" variantMapping={{ inherit: "span" }}>
                      Optional Information{` `}
                    </Typography>
                    <Typography
                      variant="inherit"
                      variantMapping={{ inherit: "span" }}
                      sx={{ fontSize: "var(--font-size-14)" }}
                    >
                      (Can fill later)
                    </Typography>
                  </div>
                </Box>

                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)", color: "black" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                >
                  <InputLabel id="age-group-select-label" style={{ color: "#000" }}>
                    Age Group (years)
                  </InputLabel>
                  <ClosableSelect
                    labelId="age-group-select-label"
                    id="age-group-select"
                    value={ageGroup}
                    label="Age Group (years)"
                    onChange={e => setAgeGroup(e.target.value)}
                  >
                    {ageGroupList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                  }}
                >
                  <InputLabel id="material-select-label" style={{ color: "#000" }}>
                    Material
                  </InputLabel>
                  <ClosableSelect
                    labelId="material-select-label"
                    id="material-select"
                    value={material}
                    label="Material"
                    onChange={e => setMaterial(e.target.value)}
                  >
                    {materialList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <TextField
                  className={styles.textfield}
                  label="Dimension LxWxH (inch)"
                  placeholder="Enter dimension as (L)ength x (W)idth x (H)eight in inches"
                  variant="outlined"
                  value={dimensions}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={e => setDimensions(e.target.value)}
                />
                <TextField
                  className={styles.textfield}
                  label="Weight (lbs)"
                  placeholder="Enter weight in pounds"
                  variant="outlined"
                  value={weight}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={e => setWeight(e.target.value)}
                />
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                  }}
                >
                  <InputLabel id="color-select-label" style={{ color: "#000" }}>
                    Color
                  </InputLabel>
                  <ClosableSelect
                    labelId="color-select-label"
                    id="color-select"
                    value={color}
                    label="Color"
                    onChange={e => setColor(e.target.value)}
                  >
                    {colorList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 2,
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                  }}
                >
                  <InputLabel id="subcolor-select-label" style={{ color: "#000" }}>
                    Sub-Color
                  </InputLabel>
                  <ClosableSelect
                    labelId="subcolor-select-label"
                    id="subcolor-select"
                    value={subColor}
                    label="Sub-Color"
                    onChange={e => setSubColor(e.target.value)}
                  >
                    {subColorList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <TextField
                  className={styles.textfield}
                  label="No of Players"
                  placeholder="Enter No of Players"
                  variant="outlined"
                  value={noPlayers}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={e => setNoPlayers(e.target.value)}
                />
                <Box className={styles.row}>
                  <Box className={styles.toggle}>
                    <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: 500 }}>
                      Battery Required
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        No
                      </Typography>
                      <Switch
                        checked={batteryRequired}
                        onChange={e => setBatteryRequired(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#ef5658",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#ef5658",
                          },
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        Yes
                      </Typography>
                    </Box>
                  </Box>
                  <Box className={styles.toggle}>
                    <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: 500 }}>
                      Battery Included
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        No
                      </Typography>
                      <Switch
                        checked={batteryIncluded}
                        onChange={e => setBatteryIncluded(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#ef5658",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#ef5658",
                          },
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        Yes
                      </Typography>
                    </Box>
                  </Box>
                  <Box className={styles.toggle}>
                    <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: 500 }}>
                      Assembly Required
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        No
                      </Typography>
                      <Switch
                        checked={assemblyRequired}
                        onChange={e => setAssemblyRequired(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#ef5658",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#ef5658",
                          },
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        Yes
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 2,
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                  }}
                >
                  <InputLabel id="difficulty-select-label" style={{ color: "#000" }}>
                    Level of Difficulty
                  </InputLabel>
                  <ClosableSelect
                    labelId="difficulty-select-label"
                    id="difficulty-select"
                    value={difficulty}
                    label="Level of Difficulty"
                    onChange={e => setDifficulty(e.target.value)}
                  >
                    {difficultyList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <TextField
                  className={styles.textfield}
                  label="Game Duration (min)"
                  placeholder="Enter Game Duration (min)"
                  onChange={e => setGameDuration(e.target.value)}
                  variant="outlined"
                  value={gameDuration}
                  sx={{
                    justifyContent: "flex-end",
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                    "& .MuiInputBase-root": { height: "56px" },
                    "& .MuiInputBase-input": { color: "rgba(0, 0, 0, 0.87)" },
                    "& .MuiInputLabel-root": { color: "black" },
                  }}
                  onChange={e => setGameDuration(e.target.value)}
                />
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": { height: "56px" },
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
                  }}
                >
                  <InputLabel
                    id="manufacturer-country-select-label"
                    style={{ color: "#000" }}
                  >
                    Manufacturer Country
                  </InputLabel>
                  <ClosableSelect
                    labelId="manufacturer-country-select-label"
                    id="manufacturer-country-select"
                    value={manufacturerCountry}
                    label="Manufacturer Country"
                    onChange={e => setManufacturerCountry(e.target.value)}
                  >
                    {countryList.map(option => (
                      <MenuItem value={option}>{option}</MenuItem>
                    ))}
                  </ClosableSelect>
                </FormControl>
                <Box
                  className={styles.callToActionBtns}
                  sx={{
                    gap: 2,
                    "@media (max-width: 856px)": {
                      gap: 1,
                    },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      height: "42px",
                      paddingX: 3,
                      fontWeight: 500,
                      backgroundColor: "#EF5658",
                      "@media (max-width: 1360px) and (min-width: 857px)": {
                        height: "36px",
                      },
                      "@media (max-width: 856px)": {
                        height: "30px",
                        paddingX: 1,
                      },
                    }}
                    onClick={() => handleSavePost(true)}
                  >
                    Save & Post
                  </Button>

                  <Button
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      color: "#ef5658",
                      borderColor: "rgba(239, 86, 88, 0.5)",
                      borderRadius: "4px",
                      height: "42px",
                      paddingX: 3,
                      fontWeight: 500,
                      "&:hover": {
                        borderColor: "#EF5658",
                        backgroundColor: "rgba(239, 86, 88, 0.1)",
                      },
                      "@media (max-width: 1360px) and (min-width: 857px)": {
                        height: "36px",
                      },
                      "@media (max-width: 856px)": {
                        height: "30px",
                        paddingX: 1,
                      },
                    }}
                    onClick={() => handleSavePost(false)}
                  >
                    Save as Draft
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      color: "#000",
                      borderColor: "#000",
                      height: "42px",
                      paddingX: 3,
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: "#fff",
                        color: "#000",
                        borderColor: "#000",
                      },
                      "@media (max-width: 1360px) and (min-width: 857px)": {
                        height: "36px",
                      },
                      "@media (max-width: 856px)": {
                        height: "30px",
                        paddingX: 1,
                      },
                    }}
                    onClick={handleCancelBtn}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </section>
        </main>
      </Box>

      <Dialog
        open={aiDlgSteps === "password"}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          handleAiDlgClose();
        }}
        // maxWidth="md"
        // maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0px 4px 12px 0px #0000001F",
            overflow: "hidden",
            // minWidth: 600,
          },
        }}
        // fullWidth
      >
        {/* Close Button */}
        <IconButton
          onClick={handleAiDlgClose}
          sx={{
            height: "24px",
            width: "24px",
            position: "absolute",
            right: 16,
            top: 16,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle>Enter Password</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          {passDlgErrorMsg && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {passDlgErrorMsg}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAiDlgClose}>Cancel</Button>
          <Button onClick={handlePassConfirm} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={aiDlgSteps === "waiting"}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          handleAiAnalysisCancel();
        }}
        // maxWidth="md"
        // maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0px 4px 12px 0px #0000001F",
            overflow: "hidden",
            py: "28px",
            px: "12px",
            gap: "10px",
          },
        }}
        // fullWidth
      >
        {/* Close Button */}
        <IconButton
          onClick={handleAiAnalysisCancel}
          sx={{
            height: "24px",
            width: "24px",
            position: "absolute",
            right: 16,
            top: 16,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent
          sx={{
            // width: 398,
            // mx: "24px",
            // mt: "112px",
            // height: 206,
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            opacity: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <video
            ref={videoRef}
            src={waitVideo}
            autoPlay
            onEnded={handleVideoEnded}
            style={{ width: "176px", height: "100px" }}
          />

          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            ReBoo AI Assistant
          </Typography>

          <Typography Variant="body2" sx={{ fontWeight: 500 }}>
            Reboo is handling your request. Please stand by.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "12px",
              gap: "4px",
              // p: 1,
            }}
          >
            <Box
              sx={{
                width: "6px",
                height: "6px",
                bgcolor: "var(--grey-100, #F5F5F5)",
                borderRadius: "50%",
              }}
            />

            <Box
              sx={{
                width: "8px",
                height: "8px",
                bgcolor: "var(--grey-200, #EEEEEE)",
                borderRadius: "50%",
              }}
            />

            <Box
              sx={{
                width: "10px",
                height: "10px",
                bgcolor: "var(--grey-300, #E0E0E0)",
                borderRadius: "50%",
              }}
            />

            <Box
              sx={{
                width: "12px",
                height: "12px",
                bgcolor: "var(--grey-400, #BDBDBD)",
                borderRadius: "50%",
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleAiAnalysisCancel}
            variant="contained"
            sx={{
              backgroundColor: "#EF5658",
              color: "white",
              borderRadius: "4px",
              // py: 0,
              height: "36px",
              fontSize: "14px",
              fontWeight: "medium",
              textTransform: "uppercase",
              minWidth: "140px",
              "&:hover": {
                backgroundColor: "#D33338",
              },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={aiDlgSteps === "result"}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          handleAiDlgClose();
        }}
        // maxWidth="md"
        // maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0px 4px 12px 0px #0000001F",
            overflow: "hidden",
            minWidth: isMobile ? "361px" : "600px",
            // paddingTop: isMobile ? "24px" : "24px",
            // paddingRight: isMobile ? "8px" : "12px",
            // paddingBottom: isMobile ? "12px" : "12px",
            // paddingLeft: isMobile ? "8px" : "12px",
            // gap: isMobile ? "12px" : "12px",
          },
        }}
        // fullWidth
      >
        {/* Close Button */}
        <IconButton
          onClick={handleAiDlgClose}
          sx={{
            height: "24px",
            width: "24px",
            position: "absolute",
            right: 16,
            top: 16,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // width: "552px",
              height: isMobile ? "26px" : "30px",
              gap: "8px",

              paddingTop: isMobile ? "48px" : "48px",
              paddingRight: isMobile ? "16px" : "24px",
              paddingBottom: isMobile ? "24px" : "24px",
              paddingLeft: isMobile ? "16px" : "24px",
              marginLeft: isMobile ? "0px" : "52px",
            }}
          >
            <ReviewsOutlinedIcon
              sx={{ height: "24px", width: "24px", color: "#424242" }}
            />
            <Typography
              variant={isMobile ? "h6" : "h4"}
              sx={{
                fontWeight: 600,
                fontSize: isMobile ? 16 : 24,
                height: isMobile ? "26px" : "36px",
              }}
            >
              Your Reboo AI Assistant at Work
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <AiResultContent
            aiRetValus={aiRes}
            onApply={handleAiAnalysisConfirm}
            onClose={handleAiDlgClose}
          />
        </DialogContent>
      </Dialog>

      {/* Alert Popup when an image is not a Toy */}
      <AlertPopup
        open={aiDlgSteps === "toyFalse"}
        onClose={handleAiDlgClose}
        title={"Wait a minute! This is not a toy"}
        message={`${notToyRes} Please try again.`}
        confirmText={"OK"}
        onConfirm={handleAiDlgClose}
        cancelText={""}
      />

      {/* Alert Popup when loading image takes time */}
      <AlertPopup
        open={aiDlgSteps === "timeOut"}
        onClose={handleAiDlgClose}
        title={"Ooops!"}
        message={"This may not be a toy. Please try a more realistic toy image."}
        confirmText={"OK"}
        onConfirm={handleAiDlgClose}
        cancelText={""}
      />

      {/* Alert Popup when image size is more that 5MB */}
      <AlertPopup
        open={aiDlgSteps === "imgSize"}
        onClose={() => setAiDlgSteps("idle")}
        title={"Ooops!"}
        message={"Sorry! The maximum size of an image is 5MB."}
        confirmText={"OK"}
        onConfirm={() => setAiDlgSteps("idle")}
        cancelText={""}
      />

      {/* Alert Popup when the number of images is more that 6 */}
      <AlertPopup
        open={aiDlgSteps === "maxImgNum"}
        onClose={() => setAiDlgSteps("idle")}
        title={"Ooops!"}
        message={"Sorry! You can upload maximum 6 images."}
        confirmText={"OK"}
        onConfirm={() => setAiDlgSteps("idle")}
        cancelText={""}
      />

      {/* Alert Popup when "Save & CLOSE" button clicked and not the images is empty */}
      <AlertPopup
        open={aiDlgSteps === "minImgNum"}
        onClose={() => setAiDlgSteps("idle")}
        title={"Ooops!"}
        message={"At least one image should be uploaded."}
        confirmText={"OK"}
        onConfirm={() => setAiDlgSteps("idle")}
        cancelText={""}
      />

      <FloatingMenu left={floatMenuLeftMargin} />
    </>
  );
};

export default ToyImageUpload;
